import React, { useState, useEffect } from 'react'
import { Container, CardGroup, Card, Button, Label, Popup, Input, Menu, MenuItem } from 'semantic-ui-react'

const MerchandiseAdmin = ({ game, viewMode, savedDict, comeFromPackage, onStateChange, onEdit }) => {
    const [activeItem, setActiveItem] = useState('resellers')
    const [gameItems, setGameItems] = useState([])
    const [inputValueDiscount, setInputValueDiscount] = useState(0)
    const [inputValueHeaderName, setInputValueHeaderName] = useState('')
    const [inputValueSubheaderName, setInputValueSubheaderName] = useState('')

    useEffect(() => {
        if (comeFromPackage) setActiveItem(viewMode)
    }, [comeFromPackage, viewMode])

    useEffect(() => {
        if (savedDict) {
            setGameItems(savedDict.gameItems || [])
        }
    }, [savedDict])

    const getName = item => {
        return activeItem === 'consumers' ? item.nameConsumer?.header : item.nameReseller
    }

    const getIsHidden = item => {
        return activeItem === 'consumers' ? item.isHiddenConsumer : item.isHiddenReseller
    }

    const getIsDiscounted = item => {
        return activeItem === 'consumers' ? item.isDiscountedConsumer : item.isDiscountedReseller
    }

    const getDiscountString = item => {
        return activeItem === 'consumers' ? item.discountRateConsumer + '% discount' : item.discountRateReseller + '% discount'
    }

    const saveItems = items => {
        setGameItems(items)
        if (comeFromPackage) {
            onEdit(items)
        } else {
            onStateChange({ gameItems: items })
        }
    }

    const handleMenuItemClicked = e => {
        switch (e.target.innerText) {
            case 'Consumers':
                setActiveItem('consumers')
                break
            case 'Resellers':
                setActiveItem('resellers')
                break
            default:
                break
        }
    }

    const handleHideButtonClicked = i => {
        const items = [...gameItems]
        if (activeItem === 'consumers') items[i].isHiddenConsumer = !items[i].isHiddenConsumer
        else items[i].isHiddenReseller = !items[i].isHiddenReseller
        saveItems(items)
    }

    const handleDiscountRateChange = (e, i) => {
        const value = e.target.value
        setInputValueDiscount(Number(value))
    }

    const handleHeaderNameChange = (e, i) => {
        const value = e.target.value
        setInputValueHeaderName(value)
    }

    const handleSubheaderNameChange = (e, i) => {
        const value = e.target.value
        setInputValueSubheaderName(value)
    }

    const handleDoubleRechargeClicked = i => {
        const items = [...gameItems]
        items[i].isDoubleRecharge = !items[i].isDoubleRecharge
        saveItems(items)
    }

    const handleDiscountSaveClicked = i => {
        const items = [...gameItems]
        if (activeItem === 'consumers') {
            items[i].isDiscountedConsumer = inputValueDiscount === 0 ? false : true
            items[i].discountRateConsumer = inputValueDiscount
            saveItems(items)
        } else {
            items[i].isDiscountedReseller = inputValueDiscount === 0 ? false : true
            items[i].discountRateReseller = inputValueDiscount
            saveItems(items)
        }
    }

    const handleNameSaveClicked = i => {
        const items = [...gameItems]
        items[i].nameConsumer.header = inputValueHeaderName
        items[i].nameConsumer.subheader = inputValueSubheaderName
        saveItems(items)
    }

    const renderCards = () => {
        const data = gameItems
        if (!data || data.length === 0 || !data) return <div style={{ color: 'white' }}>No items available</div>
        const rows = []
        for (const [i, item] of data.entries()) {
            const discountRateStr = activeItem === 'consumers' ? 'Discounted: ' + item.isDiscountedConsumer?.toString() : 'Discounted: ' + item.isDiscountedReseller.toString()
            console.log(item)
            console.log(item.cost)
            rows.push(
                <Card key={i} color={getIsDiscounted(item) ? 'red' : null} style={{ backgroundColor: item.isDoubleRecharge ? '#8B8000' : !getIsHidden(item) ? '#666888' : '#2a2b2c' }} link stackable doubling image={item.image} 
                   header={activeItem === 'consumers' ? <div>
                        <h4>{getName(item)?.replace('Diamonds', '💎')}</h4>
                        {item.nameConsumer?.subheader.replace('Diamonds', '💎')}
                    </div> : <h4>{getName(item)?.replace('Diamonds', '💎')}</h4>} 
                    meta={<span style={{ color: 'white' }}>{'Cost price: $' + (Number(item.cost) || 0).toFixed(2)}</span>}
                    description={
                        <div style={{ color: 'white' }}>
                            {getIsDiscounted(item) ? <Label style={{ marginTop: 10, marginBottom: 10 }} color='red' ribbon>{getDiscountString(item)}</Label> : null}
                            {'Hidden: ' + getIsHidden(item)}<br/>
                            {game === 'mlbb' ? <div>{'2x recharge: ' + (item.isDoubleRecharge)}<br/></div> : null}
                            {discountRateStr}<br/><br/>
                            {game === 'mlbb' ? (
                                <Button inverted color basic fluid onClick={() => handleDoubleRechargeClicked(i)} size='mini'>2x Recharge</Button>
                            ) : null}
                            <Button inverted style={{ marginTop: 10 }} color='blue' basic fluid onClick={() => handleHideButtonClicked(i)} size='mini'>{getIsHidden(item) ? 'Show Item' : 'Hide Item'}</Button>
                            <Popup on='click' position='bottom center'
                                trigger={
                                    <Button inverted style={{ marginTop: 8 }} color='blue' basic fluid content='Discount' size='mini' 
                                        onClick={e => {
                                            e.stopPropagation()
                                            setInputValueDiscount(activeItem === 'consumers' ? item.discountRateConsumer : item.discountRateReseller)
                                        }}/>
                            }>
                                <h4 style={{ color: 'black' }}>Input discount %:</h4>
                                <Input value={inputValueDiscount} type='number' onChange={(e) => handleDiscountRateChange(e, i)} inverted/>
                                <Button style={{ marginTop: 10 }} fluid color='blue' onClick={() => handleDiscountSaveClicked(i)}>Save</Button>
                            </Popup>
                            {activeItem === 'consumers' ? (
                                <Popup on='click' position='bottom center'
                                    trigger={ <Button inverted style={{ marginTop: 8 }} color='blue' basic fluid content='Edit Name' size='mini'
                                            onClick={e => {
                                                e.stopPropagation()
                                                setInputValueHeaderName(item.nameConsumer?.header)
                                                setInputValueSubheaderName(item.nameConsumer?.subheader)
                                            }}/>
                                }>
                                    <h4 style={{ color: 'white' }}>Header Name:</h4>
                                    <Input value={inputValueHeaderName} onChange={(e) => handleHeaderNameChange(e, i)} inverted/>
                                    <h4 style={{ color: 'white' }}>Subheader Name:</h4>
                                    <Input value={inputValueSubheaderName} onChange={(e) => handleSubheaderNameChange(e, i)} inverted/>
                                    <Button inverted style={{ marginTop: 15 }} fluid color='blue' onClick={() => handleNameSaveClicked(i)}>Save</Button>
                                </Popup>
                            ) : null}
                        </div>
                    }
                    extra={<span style={{ color: 'white' }}>{'Supplier Name: ' + item.nameSupplier}</span>}
                />
            )
        }
        return <CardGroup inverted style={{ marginTop: 20 }} centered doubling itemsPerRow={8}>{rows}</CardGroup>
    }

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            {comeFromPackage ? null : (
                <Menu inverted pointing secondary>
                    <MenuItem name='Resellers' active={activeItem === 'resellers'} onClick={handleMenuItemClicked}/>
                    <MenuItem name='Consumers' active={activeItem === 'consumers'} onClick={handleMenuItemClicked}/>
                </Menu>
            )}
            {renderCards()}
            <br/>
            <span style={{ color: 'white' }}>{'Total items: ' + gameItems.length}</span>
        </Container>
    )
}

export default MerchandiseAdmin